import React from "react";
import { withStyles } from "@material-ui/core/styles";
const styles = (theme) => ({
    badgeOuterContainer: { width: 80, height: 60, display: "flex", flexDirection: "column", alignItems: "center" },
    badgeValue: { fontSize: 24, color: "#599AE5", fontWeight: 500 },
    badgeLabel: { fontSize: theme.textFontSize, color: "#599AE5", fontWeight: 400 }
});
class CustomBadge extends React.Component {
    constructor() {
        super();
    }

    render() {
        const { labelText, value, classes } = this.props
        return (
            <div className={classes.badgeOuterContainer}>
                <div className={classes.badgeValue}>
                    {value}
                </div>
                <div className={classes.badgeLabel}>
                    {labelText}
                </div>
            </div>
        )
    }
}

export default withStyles(styles)(CustomBadge);